import _ from 'lodash'
import env from './environment.json'

export const isLocalDevEnv = false
export const REACT_APP_BASE_URI_GATEWAY_SERVICE = env.prod.REACT_APP_BASE_URI_GATEWAY_SERVICE
export const BASE_URI_CONTRACT_T4_SOCKET_PROD = env.prod.REACT_APP_BASE_URl_CONTRACT_T4_SOCKET
export const BASE_URI_CONTRACT18_SOCKET_PROD = env.prod.REACT_APP_BASE_URl__CONTRACT18_SOCKET
export const BASE_URI_DTC_SOCKET_PROD = env.prod.REACT_APP_BASE_URl_DTC_SOCKET
export const BASE_URI_SOCKET_PROD = env.prod.REACT_APP_BASE_URI_SOCKET

export const envs = {
  DEV:'DEV',
  QA:"QA",
  PROD:"PROD",
  AWS_DEV:"AWS_DEV"
}

export const BASE_URI_SOCKET = () =>{
  const envString = getEnvVariable('REACT_APP_BASE_URI_SOCKET')

  return envString === 'prod' ? BASE_URI_SOCKET_PROD : `${envString}`
}
export const BASE_URI = () => {
  const envString = getEnvVariable('REACT_APP_BASE_URI_GATEWAY_SERVICE')

  return envString === 'prod' ? REACT_APP_BASE_URI_GATEWAY_SERVICE : `${envString}`
}

export const BASE_URI_CONTRACT_T4_SOCKET = () => {
  const envString = getEnvVariable('REACT_APP_BASE_URl_CONTRACT_T4_SOCKET')

  return envString === 'prod' ? BASE_URI_CONTRACT_T4_SOCKET_PROD : envString
}

export const BASE_URI_CONTRACT18_SOCKET = () => {
  const envString = getEnvVariable('REACT_APP_BASE_URl__CONTRACT18_SOCKET')

  return envString === 'prod' ? BASE_URI_CONTRACT18_SOCKET_PROD : envString
}

export const BASE_URI_DTC_SOCKET = () => {
  const envString = getEnvVariable('REACT_APP_BASE_URl_DTC_SOCKET')

  return envString === 'prod' ? BASE_URI_DTC_SOCKET_PROD : envString
}

export const BASE_ENV = () => {
  return getEnvVariable('REACT_APP_ENV_NAME')
}

const getEnvVariable = (envString:any) => {
    var host = window.location.host;
    if(host){
        if(_.isEqual(host,"sltrader.matrixapps.com") || _.isEqual(host,"10.254.122.30")) {
            return 'prod';
        }

        if(_.isEqual(host,"sltrader-dev.matrixapps.com") || _.isEqual(host,"10.254.131.231")){
            return _.get(env.dev, envString);
        }
        else if(_.isEqual(host,"sltrader-qa.matrixapps.com") || _.isEqual(host,"10.254.102.244")){
            return _.get(env.qa, envString);
        }
        else if(_.isEqual(host, ('stockloantest.matrixapps.com'))){
          return _.get(env.aws_dev, envString)
        }
        else if(host?.includes('localhost')){
                return isLocalDevEnv ? _.get(env.dev, envString) : _.get(env.qa, envString);
        }
       
        
        else return _.get(env.dev, envString);
    }
    else{
        return '';
    }
}

export const getEnv = () => {
    var host = window.location.host;
    if(host){
        if(_.isEqual(host,"sltrader.matrixapps.com") || _.isEqual(host,"10.254.122.30")) {
            return envs.PROD
        }

        if(_.isEqual(host,"sltrader-dev.matrixapps.com") || _.isEqual(host,"10.254.131.231")){
            return envs.DEV
        }
        else if(_.isEqual(host,"sltrader-qa.matrixapps.com") || _.isEqual(host,"10.254.102.244")){
           return envs.QA
        }
        else if(_.isEqual(host, ('stockloantest.matrixapps.com'))){
          return envs.AWS_DEV
        }
        else if(host?.includes('localhost')){
                return isLocalDevEnv ? envs.DEV : envs.QA;
        }
        
        else return envs.DEV
    }
    else{
        return '';
    }
}

export const serviceAPIMapping: any = {
  'AUTH-SERVICE': {
    apiList: [
      '/api/auth/updateUserAndRole',
      '/api/auth/signup',
      '/api/auth/signout',
      '/api/auth/signin',
      '/api/auth/resetPassword',
      '/api/auth/refreshtoken',
      '/api/auth/modifyRole',
      '/api/auth/modifyRoleToPermission',
      '/api/auth/modifyPermission',
      '/api/auth/getUsersByClientAndAccount',
      '/api/auth/getPermissionByRole',
      '/api/auth/generateOtp?userId=',
      '/api/auth/deleteUser',
      '/api/auth/changePassword',
      '/api/auth/getRoleDetails',
      '/api/auth/getPermissionDetails',
      '/api/auth/modifyRoleToUser',
      '/api/auth/getclientEntityDetails'
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'AUTH-SERVICE',
    apiRoute: 'auth',
    apiRouteURL: `${BASE_URI()}/auth`
  },
  'COUNTERPARTY-SERVICE': {
    apiList: ['/updateCptyDetails', '/saveCptyDetails', '/getCptyDetails'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'COUNTERPARTY-SERVICE',
    apiRoute: 'cpty',
    apiRouteURL: `${BASE_URI()}/cpty`
  },
  'SECMASTER-SERVICE': {
    apiList: ['/updateSecMasterDetails', '/saveSecMasterDetails', '/getSecMaster', '/fetchSecMasterDetails'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'SECMASTER-SERVICE',
    apiRoute: 'sec',
    apiRouteURL: `${BASE_URI()}/sec`
  },
  'LOANETCONTRACT-SERVICE': {
    apiList: [
      '/getAllOpenContractsByType',
      '/fetchStockLoanKPI?account_id=',
      '/fetchContractActivity?contractId={contract_id}&bl={blFlag}'
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'LOANETCONTRACT-SERVICE',
    apiRoute: 'cntrctmntn',
    apiRouteURL: `${BASE_URI()}/cntrctmntn`
  },
  'DTC-SETTLEMENT-PROCESSOR-SERVICE': {
    apiList: [
      '/getLoanetSettleContractActivity?account_id=',
      '/getLoanetSettleActivity?account_id=',
      '/getDTCIncomingActivity?account_id=',
      '/getDTCBoxSummary?account_id='
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'DTC-SETTLEMENT-PROCESSOR-SERVICE',
    apiRoute: 'dtcsttl',
    apiRouteURL: `${BASE_URI()}/dtcsttl`
  },
  'RETURNS-SERVICE': {
    apiList: ['/returns?account_id={account_id}&cusip={cusip}', 'callback?account_id={account_id}'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'RETURNS-SERVICE',
    apiRoute: 'ret',
    apiRouteURL: `${BASE_URI()}/ret`
  },
  'REPORTING-SERVICE': {
    apiList: ['/getReportDataByFnName', '/getReportConfig'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'REPORTING-SERVICE',
    apiRoute: 'rep',
    apiRouteURL: `${BASE_URI()}/rep`
  },
  'LOCATEMANAGEMENT-SERVICE': {
    apiList: [
      '/savePreBorrow',
      '/saveLocateApproved',
      '/getPreBorrows',
      '/getMostLocate',
      '/getLocateKpi',
      '/getInventory',
      '/getQuote',
      '/getLocateList',
      '/updateLocateApproved',
      '/send-Rest-Locate-Request',
      '/send-Rest-Availability-Inquiry'
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'LOCATEMANAGEMENT-SERVICE',
    apiRoute: 'loc',
    apiRouteURL: `${BASE_URI()}/loc`
  },
  'CONTRACT-BOOKING-SERVICE': {
    apiList: [
      '/updateContract',
      '/getOpenContractValueByCptyID',
      '/contractStatus',
      '/contractReturn',
      '/contractRecall',
      '/contractMaintenanceRequest',
      '/bookContract'
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'CONTRACT-BOOKING-SERVICE',
    apiRoute: 'book',
    apiRouteURL: `${BASE_URI()}/book`
  },
  'TRADE-SERVICE': {
    apiList: [
      '/api/v1/updateTradeState',
      '/api/v1/saveTradeState',
      '/api/v1/saveTradeStateList',
      '/api/v1/getTradesStateByID/{uiTradeId}',
      '/api/v1/getTradesState/{trader}',
      '/api/v1/deleteTradeState'
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'TRADE-SERVICE',
    apiRoute: 'trade',
    apiRouteURL: `${BASE_URI()}/trade/api/v1/`
  },
  'CONTRACT-LISTENER-SERVICE': {
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'CONTRACT-LISTENER-SERVICE',
    apiRoute: 'cntrctlstnr',
    apiRouteURL: `${BASE_URI()}/cntrctlstnr`
  },
  'SUPPLYMANAGEMENT-SERVICE': {
    apiList: ['/updateLenderDetailsList', '/saveLenderDetailsList', '/getLenderDetails'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'SUPPLYMANAGEMENT-SERVICE',
    apiRoute: 'supp',
    apiRouteURL: `${BASE_URI()}/supp`
  },
  'RECALL-SERVICE': {
    apiList: ['/getgetRecallActivityByLenderId', '/getRecallDetails', '/getRecallDetailsAndOutstandingLoans'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'RECALL-SERVICE',
    apiRoute: 'rcll',
    apiRouteURL: `${BASE_URI()}/rcll`
  },
  'AUTO-BORROW-SERVICE': {
    apiList: [
      '/getAutoborrowBatchDetails',
      '/getAutoborrowOrderDetails?batch_id=',
      '/submitTradeBatch',
      '/createBulkTradeRecords',
      '/fetchAbCptyId?account_id={account_id}',
      '/fetchBatchTimeline?batchId={batchId}',
      '/rollOverForTimedoutCptyHop'
    ],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'AUTO-BORROW-SERVICE',
    apiRoute: 'abrrw',
    apiRouteURL: `${BASE_URI()}/abrrw`
  },
  'RATEMANAGEMENT-SERVICE': {
    apiList: ['/updateRateDetailsList', '/saveRateDetailsList', '/getRateDetails'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'RATEMANAGEMENT-SERVICE',
    apiRoute: 'rate',
    apiRouteURL: `${BASE_URI()}/rate`
  },
  'TRADING-APPS-SERVICE': {
    apiList: ['/submitTradeBatch'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'TRADING-APPS-SERVICE',
    apiRoute: 'tap',
    apiRouteURL: `${BASE_URI()}/tap`
  },
  'DTC-UNSOLICITED-SERVICE': {
    apiList: [],
    port: 18083,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'DTC-UNSOLICITED-SERVICE',
    apiRoute: 'dtcunsl',
    apiRouteURL: `${BASE_URI()}/dtcunsl`
  },
  LNETUSOL: {
    apiList: [],
    port: 19093,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'LNETUSOL',
    apiRoute: 'lnetunsl',
    apiRouteURL: `${BASE_URI()}/lnetunsl`
  },
  LOANETLCOR: {
    apiList: ['/lcorAutoBorrow'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    id: 'LOANETLCOR',
    apiRoute: 'lcr',
    apiRouteURL: `${BASE_URI()}/lcr`
  },
  WEMATCH: {
    id: 'WEMATCH',
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: '',
    apiRouteURL: `${BASE_URI()}`
  },
  'EQUILEND-NGT': {
    id: 'EQUILEND-NGT',
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: '',
    apiRouteURL: `${BASE_URI()}`
  },
  'EQUILEND-ECS': {
    id: 'EQUILEND-ECS',
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: '',
    apiRouteURL: `${BASE_URI()}`
  },
  SHAREGAIN: {
    id: 'SHAREGAIN',
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: '',
    apiRouteURL: `${BASE_URI()}`
  },
  ESECLENDING: {
    id: 'ESECLENDING',
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: '',
    apiRouteURL: `${BASE_URI()}`
  },
  'SOCKET-PUSH-SERVICE': {
    id: 'SOCKET-PUSH-SERVICE',
    apiList: [],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: 'scktpsh',
    apiRouteURL: `${BASE_URI()}/scktpsh`
  },
  'SERVICE-MANAGER': {
    id: 'SERVICE-MANAGER',
    apiList: ['/eureka/apps'],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: 'discovery',
    apiRouteURL: `${BASE_URI()}/discovery`
  },
   'LEMUR-SERVICE': {
    id: 'LEMUR-SERVICE',
    apiList: [''],
    port: 8092,
    baseURL: BASE_URI(),
    type: 'Java',
    apiRoute: 'discovery',
    apiRouteURL: `${BASE_URI()}/risk`
  },
}
